import { useEffect } from "react";
import { AppRouter } from "./router";
import { Toaster } from "sonner";
import { useThemeStore } from "@/frontend/stores/themeStore";

const App = () => {
  const { initTheme, resolvedTheme } = useThemeStore();

  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return (
    <>
      <AppRouter />
      <Toaster position="top-right" richColors theme={resolvedTheme} />
    </>
  );
};

export default App;
